import contractApi from '../../api/contract.api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
	// 获取订单列表
	findOrderList(context, data) {
		return contractApi.findOrderList(data)
	},
	// 备注合同
	remarkContract(context, data) {
		return contractApi.remarkContract(data)
	},
	// 获取合同列表
	findContractList(context, data) {
		return contractApi.findContractList(data)
	},
	// 草稿作废
	invalidContract(context, data) {
		return contractApi.invalidContract(data)
	},
	// 草稿转正式合同
	generFormalContract(context, data) {
		return contractApi.generFormalContract(data)
	},
	// 生成草稿合同
	generDraftContract(context, data) {
		return contractApi.generDraftContract(data)
	},
	// 预览
	previewDraftContract(context, params) {
		return contractApi.previewDraftContract(params)
	},

	// 下载
	downloadFormatContract(context, params) {
		return contractApi.downloadFormatContract(params)
	},
	// 获取验证码
	sendMessageToTel(context, params) {
		return contractApi.sendMessageToTel(params)
	},
	// 校验验证码
	checkMessageToTel(context, params) {
		return contractApi.checkMessageToTel(params)
	}
}

export default { state, getters, mutations, actions, namespaced: true}
